import React, { useState, useRef, useCallback, useEffect } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
//import { useGlobalSpinnerContext } from "../../../Context/GlobalSpinnerContext";
import { Checkbox } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { BsThreeDotsVertical } from "react-icons/bs";
import PauseIcon from "@mui/icons-material/PauseCircleFilled";
import Tooltip from "@mui/material/Tooltip";

const RenderRow = React.memo(
  ({
    rowData,
    headerList,
    index,
    handleAction,
    handleCheckBoxClick,
    reportCode,
  }) => {
    const { localization } = useLanguageContext();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState("");
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const buttonRef = useRef(null);

    const [actionListTracker, setActionListTracker] = useState("");
    const refDropDown = useRef(null);
    const [_className, set_className] = useState("datedropdown-menu");

    const _key = rowData[0].value;
    const isActive = rowData[2].value === "1" ? true : false;
    const orderStatus = {
      beend: localization.beend,
      offen: localization.open,
      inarbeit: localization.inprogress,
      ubersprungen: localization.skipped,
    };
    useEffect(() => {
      if (isOpen) {
        const dropdownElement = refDropDown.current;
        const dropdownElementRef = dropdownElement.getBoundingClientRect().top;
        const dropdownHeight = refDropDown.current.offsetHeight;
        const viewportHeight = window.innerHeight;
        if (
          viewportHeight - dropdownElementRef <
          actionListTracker.length * 50
        ) {
          set_className("datedropdown-menuUp");
        } else {
          set_className("datedropdown-menu");
        }
      }
    }, [isOpen, actionListTracker.length]);

    const handleIconClick = useCallback(
      (itemId) => {
        const rowName = selectedRow === itemId ? "" : itemId;
        setSelectedRow(rowName);
        setIsOpen(rowName !== "");
      },
      [selectedRow]
    );

    const handleMouseOut = useCallback(() => {
      setSelectedRow("");
      setIsOpen(false);
    }, []);

    const handleCheckboxChange = useCallback(
      (index, _value) => {
        setSelectedCheckbox(index === selectedCheckbox ? null : index);
        handleCheckBoxClick(_value);

        // setEquipmentSelected(index === selectedCheckbox ? null : _value);
      },
      [selectedCheckbox]
    );

    const renderCell = (value, headerName) => {
      const header = headerName.toLowerCase();
      let icon, backgroundColor, textColor, tooltipText;
      // if (header.toLowerCase() === "orderstatus") {
      //   return orderStatus[value.toLowerCase()];
      // }
      if (header === "anlagestatus") {
        const isValueOk = value.toLowerCase() === "inbe"; // Check if the value is 'ok'
        icon = isValueOk ? (
          <DoneIcon style={{ color: "#0A470A" }} />
        ) : (
          <CloseIcon style={{ color: "#A00" }} />
        );
        backgroundColor = isValueOk ? "#E3FBE3" : "#FBE3E3";
        textColor = isValueOk ? "#0A470A" : "#A00";
        tooltipText = isValueOk
          ? localization.eqIsActive
          : localization.eqIsNotActive;
        value = isValueOk ? localization.active : localization.inActive;
      } else if (header === "nio") {
        // icon = <PauseIcon style={{ color: "#171A1C" }} />;
        // backgroundColor = "#CDD7E1";
        // textColor = "#171A1C";
        // tooltipText = value.toLowerCase() === "y" ? "Status is Paused" : "";
        backgroundColor =
          value.toLowerCase() === "true" ? "#FBE3E3" : "#E3FBE3";
        textColor = value.toLowerCase() === "true" ? "#A00" : "#0A470A";

        const nioText =
          value.toLowerCase() === "true" ? localization.nio : localization.io;
        return (
          <Tooltip>
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: "0 6px 0 6px",
                display: "flex",
                alignItems: "center",
                borderRadius: "15px",
                color: textColor,
              }}
            >
              <span>{nioText}</span>
            </div>
          </Tooltip>
        );
      } else {
        return value; // Return value as is for other headers
      }

      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            paddingLeft: 6,
            paddingRight: 6,
            background: backgroundColor,
            borderRadius: 24,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <Tooltip title={tooltipText} arrow sx={{ fontSize: "14px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 20,
                height: 20,
              }}
            >
              {icon}
            </div>
          </Tooltip>
          <div
            style={{
              color: textColor,
              fontSize: 12,
              fontFamily: "Inter",
              fontWeight: "500",
              wordWrap: "break-word",
              display: "flex",
              alignItems: "center",
            }}
          >
            {value}
          </div>
        </div>
      );
    };

    return (
      <React.Fragment key={index + _key}>
        <tr>
          {/* <td className="tableCheckBoxCell">
            <Checkbox
              disabled={true}
              checked={selectedCheckbox === index}
              onChange={() => handleCheckboxChange(index, _key)}
            />
          </td> */}
          {headerList.map((item, ind) => {
            if (item.isVisible) {
              const actionStatus = item.actions.length > 0;
              const actionlist = item.actions;

              return (
                <td
                  className={`${
                    actionStatus
                      ? "d-flex justify-content-between align-items-center border-left-none"
                      : ""
                  } ${
                    item.align === "R"
                      ? "text-right"
                      : item.align === "L"
                      ? "text-left"
                      : item.align === "C"
                      ? "text-center"
                      : ""
                  }`}
                  key={item.name + "Col" + ind}
                  style={{
                    backgroundColor: `${rowData[ind].stype}`,
                  }}
                >
                  {actionStatus ? (
                    <>
                      <span className="rowSpan">
                        {renderCell(rowData[ind].value, item.name)}
                      </span>
                      <span
                        onMouseEnter={(e) => {
                          e.preventDefault();
                          setActionListTracker(actionlist);
                          handleIconClick(index);
                        }}
                        onMouseLeave={(e) => {
                          e.preventDefault();
                          handleMouseOut();
                        }}
                      >
                        <button className="custom-button">
                          <BsThreeDotsVertical className="svgIcon" />
                          {selectedRow === index && isOpen && (
                            <div
                              className="position-relative"
                              ref={refDropDown}
                            >
                              <div className={`${_className} active`}>
                                <ul id="gridTable" className="p-0 liStyle">
                                  {actionlist.map((elemnt, index) => {
                                    const isMatchingCondition =
                                      (isActive &&
                                        elemnt.name.toLowerCase() ===
                                          "active") ||
                                      (!isActive &&
                                        elemnt.name.toLowerCase() ===
                                          "deleteequipment");
                                    if (isMatchingCondition) {
                                      return null;
                                    } else {
                                      return (
                                        <li
                                          key={index}
                                          className="liHover d-flex justify-content-start"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleAction(
                                              elemnt.name,
                                              rowData,
                                              headerList,
                                              rowData[1].value
                                            );
                                          }}
                                        >
                                          {elemnt.text}
                                        </li>
                                      );
                                    }
                                  })}
                                </ul>
                              </div>
                            </div>
                          )}
                        </button>
                      </span>
                    </>
                  ) : (
                    <>{renderCell(rowData[ind].value, item.name)}</>
                  )}
                </td>
              );
            }
            return null;
          })}
        </tr>
      </React.Fragment>
    );
  }
);

export default RenderRow;
